var HashMap = require("./hashMap.js");
var inherit = require("../general.js").inherit;

var defaultCompare = function(a,b){
    return a<b? -1: a>b? 1:0;
};

// TODO: current implementation uses ordered array: put, remove = O(n); get, contains, forEach = O(1); If necessary put and remove can be improved to O(log(n)) with BST
var SortedMap = function (hash, compare) {
    HashMap.call(this, hash);
    this._compare = compare || defaultCompare;
    this._order = [];
};
inherit(SortedMap, HashMap);

var WeightedPair = function(key, val, weight) {
    this.key = key;
    this.val = val;
    this.weight = weight == undefined ? key : weight; // by default sort by key, unless weight is given
};

SortedMap.prototype.usePair = function() {
    return true;
};

SortedMap.prototype.put = function(key, val, weight){
    if (key == undefined) return;
    var hash = this._hash(key);
    var el = new WeightedPair(key, val, weight);

    if (this._content.has(hash)) this.remove(key);
    this._content.set(hash, el);

    for (var idx = this._order.length-1; idx>=0; idx--){    // loop in reverse order: equal weight elements are sorted in insertion order
        if (this._compare(el.weight, this._order[idx].weight) >= 0) break;
    }
    this._order.splice(idx+1, 0, el);
};

SortedMap.prototype.putAll = function(map){
    var self = this;
    map.forEach(function(key, value, weight) {
        self.put(key, value, weight);
    });
};

SortedMap.prototype.getIndex = function(idx){
    if (idx < 0) idx = this.size() + idx;
    if (idx >= 0 && idx < this.size()) return this._order[idx].val;
};

SortedMap.prototype.indexOf = function(key){
    if (key == undefined) return -1;
    var hash = this._hash(key);
    return this._order.indexOf(this._content.get(hash));   // can be improved from O(n) to O(log(n)) with binary search in ordered array
};

SortedMap.prototype.forEach = function(f){
    var initialLength = this._order.length;
    for (var idx=0; idx<this._order.length; idx++) {
        var el = this._order[idx];
        f(el.key, el.val, el.weight, idx);
        console.assert(this._order.length == initialLength, "Don't change the content of a collection while iterating (forEach)");
    }
};

SortedMap.prototype.remove = function(key){
    if (key == undefined) return;
    var hash = this._hash(key);
    var pair = this._content.get(hash);
    if (pair !== undefined) {
        this._order.splice(this._order.indexOf(pair), 1);
        this._content.delete(hash);
        return pair.val;
    }
};

SortedMap.prototype.copy = function() {
    var result = new SortedMap(this._hash, this._compare);
    result.putAll(this);
    return result;
};

SortedMap.prototype.values = function(){
    var result = [];
    for (var idx=0; idx<this._order.length; idx++) {
        result.push(this._order[idx].val);
    }
    return result;
};

SortedMap.prototype.keys = function(){
    var result = [];
    for (var idx=0; idx<this._order.length; idx++) {
        result.push(this._order[idx].key);
    }
    return result;
};

// TODO: when necessary: overwrite functions [forEachPair, removeWhere, filter, map, reduce, some, every, equals] with extended callback function

module.exports = SortedMap;